
/**
 * 'Extensions' of Marionette and Backbone.
 * TODO: break apart separately into Marionette and Backbone.
 */

var Backbone = require('backbone'),
    Marionette = require('marionette');

/**
 * Note: requests target to have triggerMethod Method mixed in to receive
 * -- really 'triggerMethod'.
 */
Marionette.blindTriggerOn = function(target, name) {

    if (!target)
        return;

    var args =  Array.prototype.slice.call(arguments, 1); // includes name and any arguments passed

    if (target instanceof Array) {
        _.each(target, function(t) {
            t && t.triggerMethod && t.triggerMethod.apply(t, args);
        });
    } else {
        target.triggerMethod && target.triggerMethod.apply(target, args);
    }

};


/**
 * Note: temp until get rid of the last legacy ones
 */
_.extend( Backbone.View.prototype, {

    /**
     * Remove a view's childViews and then itself.
     * Will call at top level of hierarchy to remove all.
     * use justEmpty if you want to empty the div, rather than remove it
     */
    destroy: function(justEmpty) {

        if (this.childViews) {

            _.each(this.childViews, function(cv) {
                if (cv && cv.destroy) {
                    cv.destroy();
                    cv = null;
                }
            });

            this.childViews = null;
        }

        if (justEmpty) {

            this.$el.empty();
            this.stopListening();

        } else {

            this.remove();
        }

    },
    /*
    *  Helper to allow using of wrapper div in template without 'doubling' it.
    *  Used when top left el left in template and not mentioned in bb view -- done post render.
    *  Events undelegated, then delegated.
    * */
    unwrap: function() { //
        this.setElement( this.$el.children().first().end() );
    },

    /**
     * Literally all code from Backbone.View.remove replacing this.$el.remove(), with this.$el.empty().
     * Override remove on view instances to call this method.
     */
    emptyRemove: function() {
        this.$el.empty();
        this.stopListening();
        return this;
    }

});



/**
 * Extend Model Prototype
 */

_.extend( Backbone.Model.prototype, {

    triggerMethod: Marionette.triggerMethod,

    /**
     * Must use trigger method.
     * For naming, make clear this isn't the typical destroy
     */
    onDestroy: function() {
        this.erase();
    },

    erase: function() {

        this.clear({silent: true});
        this.stopListening();
        this.off();

        /* delete instance props */
        _.each( _.keys(this), function(key) {
            delete this[key];
        }, this);

    },
    /* toggle boolean attribute */
    toggle: function(attr, options) {
        this.set( attr, !this.get(attr), options ? options : {} );
    },

    // Allow for options to be passed to the constructor, like parse
    clone: function( options ) {
        return new this.constructor( this.attributes, options );
    }

});


_.extend( Backbone.Collection.prototype, {

    triggerMethod: Marionette.triggerMethod,

    onDestroy: function() {
        this.erase(); //for naming, make clear this isn't the typical destroy
    },
    /**
     * Reset collection with no models/out triggering event.
     * Could patch with destroy the model destroy above.
     */
    erase: function() {
        Backbone.Collection.prototype.reset.call(this, [], {silent: true});
        this.off();
        this.stopListening();
    }

});



/**
 * Forward array of fn names to be called off target object with same arguments
 * -- add to the addToObject if exists.
 * Just trying to reduce some boilerplate.
 * Allows the functions to be defined on the other object  -- they must exist to be invoked correctly.
 * Works coming from, not to ...
 */
Backbone.fwdFnsOnObjAsFn = function(target, callFn, fnNames, fnHolder) {

    fnHolder = fnHolder || this;
    callFn = callFn || 'trigger';
    _.each(fnNames, function(c) {
        fnHolder[c] = function() {
            target[callFn].apply(target, [c].concat(_.toArray(arguments)));
        };
    }, this);

};


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/FV/extension/backbone.js
 ** module id = 66
 ** module chunks = 0
 **/